import { promptList } from './bigConfig';

export type FrontWebConfigKeyType =
  | 'keyword_analysis_shortcut' // keyword analysis页配置快捷选中词
  | 'default_no_show_filter' // 前端默认不展示的过滤器
  | 'ai_replace_text' // gpt内容回来后需要替换的内容
  | 'have_video_ai_channel' // 有video ai 的渠道
  | 'ai_prompt_list' // 所有的ai prompt列表
  | 'ai_default_prompt' // 默认的ai prompt
  | 'topic_prompt' // topic prompt
  | 'nikke_default_prompt' // nikke prompt
  | 'video_default_prompt' // video prompt
  | 'key_opinion_prompt' // key opinion prompt
  | 'video_page_prompt' // video 页面表格的 prompt
  | 'publications_prompt' // channel share rankings 的 top publications summary
  | 'timezone' // 游戏时区
  | 'video_page_danmuku'
  | 'have_video_danmuku_ai_channel' // 拥有视频弹幕ai的渠道
  | 'streaming_tab' // Streaming页面头部tab
  | 'key_opinions_tab' // Key Opinions页面game store Tab文案展示
  | 'kol_tags_filter' // 品牌网红列表页 - 发帖人类型筛选器选项
  | 'kol_tags_brand_options'
  | 'kol_tags_genre_options'
  | 'has_release_time_shortcut'
  | 'real_time_opinions_no_data_range'
  | 'hot_events_fixed_one_day'
  | 'external_data_sources'
  | 'real_time_opinions_refresh_time'
  | 'no_selected_monitor_method'
  | 'real_time_streaming_refresh_time'
  | 'mobile_filter_high_game'
  | 'default_filter_rollback_hours' // 过滤器回退时间，如果配置1，当0点-1点之间默认时间为前一天; 如果配置2，当0-2点之间默认时间为前一天
  | 'hide_weekly_report_tags' // TODO: 后续可以移除 是否展示周报标签内容;
  | 'hide_weekly_report_ugc_video' // TODO: 后续可以移除 是否展示周报UGC视频内容;
  | 'keyword_topic_shortcut'
  | 'ai_insights_report_list' // 配置 AI洞察报告 的自定义Tab
  | 'has_event_attribution'
  | 'custom_ai_prompt'
  | 'default_no_selected_channels'; // 全局默认不选中的渠道（首次回显剔除），按渠道类型分组

/**
 * 第二优先级配置: 根据key获取兜底的默认配置
 */
export const defaultConfig: { [key in FrontWebConfigKeyType]: any } = {
  keyword_analysis_shortcut: [],
  keyword_topic_shortcut: [],
  default_no_show_filter: [],
  ai_replace_text: ['```markdown', '```'],
  have_video_ai_channel: [{ channel: 'youtube' }, { channel: 'twitch' }],
  have_video_danmuku_ai_channel: [{ channel: 'twitch' }],
  ai_prompt_list: promptList,
  ai_default_prompt: ['default1', 'default2'],
  topic_prompt: {
    gpt: ['default1', 'default2', 'topic1', 'topic2', 'topic3'],
    deepseek: ['topic_deepseek2'],
    gemini: [
      'default1',
      'default2',
      'topic_deepseek2',
      'topic1',
      'topic2',
      'topic3',
    ],
  },
  nikke_default_prompt: ['nikke1'],
  video_default_prompt: ['video1'],
  key_opinion_prompt: {
    gpt: ['default1', 'default2'],
    deepseek: ['deepseek1'],
    gemini: ['default1', 'default2', 'deepseek1'],
  },
  video_page_prompt: ['video2'],
  publications_prompt: ['publications'],
  video_page_danmuku: ['video_danmuku'],
  timezone: 0,
  streaming_tab: [],
  key_opinions_tab: 'game_store',
  kol_tags_filter: [
    { text: 'Partnered', textCN: '合作网红', value: 'partnered' },
    { text: 'Creator Hub Incentive', textCN: '生态激励', value: 'creatorhub' },
    {
      text: 'Others',
      textCN: '其他',
      value: `active&potential&core&multi-gamer&not-tag&official-gaming-media`,
    },
  ],
  kol_tags_brand_options: [
    {
      text: 'Partnered',
      textCN: '合作网红',
      value: 'partnered',
      color: '#29B569',
      background: 'rgba(119, 224, 151, 0.2)',
    },
    {
      text: 'Active',
      textCN: '活跃网红',
      value: 'active',
      color: '#45A1CC',
      background: 'rgba(94, 200, 241, 0.12)',
    },
    {
      text: 'Potential',
      textCN: '潜力网红',
      value: 'potential',
      color: '#6E7794',
      background: 'rgba(110, 119, 148, 0.12)',
    },
    {
      text: 'No Tags',
      textCN: '无标签',
      value: 'not-tag',
    },
    {
      text: 'Core',
      textCN: '核心网红',
      value: 'core',
      color: '#F19E55',
      background: '#FDF1E7',
    },
    {
      text: 'Multi-Gamer',
      textCN: '多游戏网红',
      value: 'multi-gamer',
      color: '#3780DF',
      background: 'rgba(208, 228, 254, 1)',
    },
    {
      text: 'Official Gaming Media',
      textCN: '权威游戏媒体',
      value: 'official-gaming-media',
      color: '#29B569',
      background: 'rgba(119, 224, 151, 0.2)',
    },
    {
      text: 'Monthly Returning',
      textCN: '月度回流',
      value: 'monthly-returning',
      color: '#AD53D4',
      background: 'rgba(173, 83, 212, 0.12)',
      no_filter: true,
    },
    {
      text: 'Quarterly Returning',
      textCN: '季度回流',
      value: 'quarterly-returning',
      color: '#7F6FF1',
      background: 'rgba(127, 111, 241, 0.12)',
      no_filter: true,
    },
  ],
  kol_tags_genre_options: [
    {
      text: 'Partnered',
      textCN: '合作网红',
      background: 'rgba(119, 224, 151, 0.2)',
      color: '#29b569',
      value: 'partnered',
    },
    {
      text: 'Core: Brand-Related',
      textCN: '核心：品牌相关',
      background: '#172F80',
      color: '#fff',
      value: 'brand-related',
    },
    {
      text: 'Subcore: Competitor-Related',
      textCN: '次核心：竞品相关',
      background: '#3865CC',
      color: '#fff',
      value: 'competitor-related',
    },
    {
      text: 'Genre: Genre-Related',
      textCN: '品类：品类相关',
      background: '#7CADFC',
      color: '#fff',
      value: 'genre-related',
    },
    {
      text: 'Variety',
      textCN: '综合类玩家',
      background: '#D0E4FE',
      color: '#262832',
      value: 'variety',
    },
    {
      text: 'Multi-Gamer',
      textCN: '多游戏网红',
      background: 'rgba(208, 228, 254, 1)',
      color: '#3780DF',
      value: 'multi-gamer',
    },
    {
      text: 'Core',
      textCN: '核心网红',
      background: '#FDF1E7',
      color: '#F19E55',
      value: 'core',
    },
    {
      text: 'Others',
      textCN: '其他',
      background: '#D7F0FF',
      color: '#262832',
      value: 'others',
    },
  ],
  has_release_time_shortcut: 'no',
  real_time_opinions_no_data_range: 1,
  hot_events_fixed_one_day: 'yes',
  external_data_sources: ['levelup'],
  real_time_opinions_refresh_time: 2,
  real_time_streaming_refresh_time: 5,
  no_selected_monitor_method: [], // "战锤40k暗潮", "youtube_keyword#_#fatshark-youtube"
  default_filter_rollback_hours: 1,
  mobile_filter_high_game: [],
  hide_weekly_report_tags: true,
  hide_weekly_report_ugc_video: true,
  ai_insights_report_list:
    [] /** { id: 100000, nameEn: "Daily Report", nameCn: "日报",reportType: "menu",kind: 5,type: 1,}*/,
  has_event_attribution: false,
  custom_ai_prompt: {
    gemini: ['custom_default1', 'custom_default2'],
  },
  default_no_selected_channels: {},
};

// 全局默认不请求的key
export const subUnRequestType: Array<string> = [
  'keyword_topic_shortcut',
  'keyword_analysis_shortcut',
  'ai_prompt_list',
  'CustomAISummary',
  'KeywordAnalysis',
  'URLAnalysis',
  'AIInsightsReport',
  'kol_accounts',
  'VideoReport',
  'kol_tags_brand_options',
  'kol_tags_genre_options',
];

export type ValueType =
  | 'string'
  | 'array'
  | 'object'
  | 'number'
  | 'boolean'
  | 'undefined';
